import React from "react";
import Poster from "../../assets/poster.jpeg";

const FormContainer = (props) => {
  return (
    <div className="form_container">
      <div className="flex column justifyCenter alignCenter w-100 on_desktop">
        <img src={Poster} alt="poster" className="auth_form_image" />
      </div>
      <div className="form_section">
        {props.children}
      </div>
    </div>
  );
};

export default FormContainer;
